import React, { useCallback, useEffect } from "react"

import i18nCommonData from "@/locales/zh-CN.json"
import Reg from "@/utils/reg"
import Input from "../Input"

import styles from "./index.module.less"
import classNames from "classnames"
const InputAccount: React.FC<{
    scene: string
    account: string
    setAccount: React.Dispatch<React.SetStateAction<string>>
    handleKeyUp: (e: React.KeyboardEvent<HTMLInputElement>) => void
}> = ({ scene, account, setAccount, handleKeyUp }) => {
    const handleInputAccount = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value

            // if (scene === "account") {
                // 密码登录，不限制
            setAccount(value)
            // } else {
            //     // 短信登录，只接受数字
            //     Reg.isPhoneInput.test(value) && setAccount(value)
            // }
        },
        [scene, setAccount]
    )

    // useEffect(() => {
    //     // 切换到短信登陆，不符合的都清空
    //     if (scene === "smsCode" && !Reg.isPhoneInput.test(account)) {
    //         setAccount("")
    //     }
    // }, [scene, account, setAccount])

    return (
        <>
            <Input
                type="text"
                autoComplete="off"
                className={classNames(styles.account,"emailAc")}
                value={account}
                onChange={handleInputAccount}
                onKeyUp={handleKeyUp}
                placeholder={
                    scene === "account"
                        ? i18nCommonData["login.placeholder.account"]
                        : i18nCommonData["login.placeholder.phone"]
                }
            />
        </>
    )
}

export default InputAccount
